import { useEffect } from "react";

import { bindEscapedBuilderMenus } from "@/pages/admin/escapedBuilderMenu";

/**
 * Keep an open DocuSeal settings menu outside the scrolling field lists.
 * The builder attaches its shadow root after load, so poll for it the same way
 * the server-variable marks do.
 */
export function useEscapedBuilderMenus(root: HTMLElement | null) {
  useEffect(() => {
    if (!root) return;
    let shadow: ShadowRoot | null = null;
    let unbind: (() => void) | undefined;

    const attach = () => {
      const next = root.querySelector("docuseal-builder")?.shadowRoot ?? null;
      if (next === shadow) return;
      unbind?.();
      shadow = next;
      unbind = shadow ? bindEscapedBuilderMenus(shadow) : undefined;
    };

    attach();
    const poll = window.setInterval(attach, 250);
    return () => {
      window.clearInterval(poll);
      unbind?.();
    };
  }, [root]);
}
